export enum EDateSelectionType {
    NoSelection,
    SingleDate,
    DateRange,
    Weekly
}